import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'
const Footer = ({footitems}) => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Anmol</a>
      <ul className='permalinks'>
      {footitems.map((footitem)=>(
          <li><a href={footitem.sec}>{footitem.title}</a></li>
      ))}
      </ul>
      {/* <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonial">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul> */}

      <div className='footer__socials'>
        <a href="https://www.facebook.com/anmol.sharma.79274" target='_blank'><FaFacebookF/></a>
        <a href="https://www.instagram.com/_anmolsharma23/" target='_blank'><FiInstagram/></a>
        <a href="https://twitter.com/AnmolSh30407651" target='_blank'><IoLogoTwitter/></a>
      </div>

      <div className='footer__copyright'>
        <small>&copy; Anmol Sharma</small>
      </div>
    </footer>

  )
}

export default Footer